import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { first } from "rxjs/operators";

import { ShareMessageResponse } from "@shared/Interfaces/share-message-response.interface";
import { FileHandlerService } from "@shared/Services/fileHandler.service";

import { OptionsType } from "@salud/shared/Types/options-type.interface";

import { FacturasRepository } from "../Repositories/facturas.repository";
import { DetalleFactura } from "../Types/Interfaces/detalle-factura.interface";
import { CreditNoteEmail, FacturaEmail } from "../Types/Interfaces/factura-email.interface";
import { Factura, FacturaStatus, FacturaType } from "../Types/Interfaces/factura.interface";
import { FacturasFilter, DetalleFacturasFilter } from "../Types/Interfaces/facturas-filter.interface";

@Injectable({
  providedIn: "root",
})
export class FacturasService {
  constructor(private facturaRepository: FacturasRepository, private fileHandlerService: FileHandlerService) {}

  public getFacturas(facturasFilter: FacturasFilter): Observable<Factura[]> {
    return this.facturaRepository.getFacturas(facturasFilter);
  }

  public getFacturaTypes(): Observable<FacturaType[]> {
    return this.facturaRepository.getFacturaTypes();
  }
  public getFacturaStatus(): Observable<FacturaStatus[]> {
    return this.facturaRepository.getFacturaStatus();
  }

  public getFacturasQuantities(): Observable<OptionsType[]> {
    return this.facturaRepository.getFacturasQuantities();
  }
  public getDetalleFacturas(detalleFacturasFilter: DetalleFacturasFilter): Observable<DetalleFactura[]> {
    delete detalleFacturasFilter.tipoFactura;
    return this.facturaRepository.getDetalleFacturas(detalleFacturasFilter);
  }

  public getFacturasReport(factura: Factura): void {
    if (factura.tipoDocumento === "FACTURA") {
      const { contrato, identificacion, tipoIdentificacion, numero } = factura;
      this.facturaRepository
        .getFacturasReport({
          numeroContrato: contrato,
          numeroIdentificacion: identificacion,
          tipoIdentificacion,
          numeroFactura: numero,
        })
        .pipe(first())
        .subscribe(this.fileHandlerService.openPdfInNewTab);
    } else {
      this.facturaRepository
        .getNotaCreditoReport({ numeroFactura: factura.numero })
        .pipe(first())
        .subscribe(this.fileHandlerService.openPdfInNewTab);
    }
  }

  public sendCreditNoteEmail(creditNote: CreditNoteEmail): Observable<ShareMessageResponse> {
    return this.facturaRepository.sendCreditNoteEmail(creditNote);
  }

  public sendFacturaEmail(creditNote: FacturaEmail): Observable<ShareMessageResponse> {
    return this.facturaRepository.sendFacturaEmail(creditNote);
  }
}
